"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setColumnFilters = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var columnFilterSlice = toolkit_1.createSlice({
    name: 'filters',
    initialState: {
        chosenColumnFilters: [],
    },
    reducers: {
        setColumnFilters: function (state, action) {
            state.chosenColumnFilters = (action.payload === null) ? [] : action.payload;
        },
    },
});
exports.setColumnFilters = columnFilterSlice.actions.setColumnFilters;
exports.default = columnFilterSlice.reducer;
